import { State } from '@/store/modules/campaign/state';
import { CampaignData } from '@/typings/interfaces/data/campaign';
import { CampaignModel, CampaignState } from '@/models/CampaignModel';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/state';
import { FlowpageModel } from '@/components/layout/FlowpageModel';

export type Getters<S = State> = {
  demoToken(state: S): string | undefined;
  data(state: S): CampaignData | undefined;
  model(state: S): CampaignModel | undefined;
  state(state: S): CampaignState | undefined;
  flowId(state: S): number | undefined;
  flowIndex(state: S): number | undefined | null;
  popoverId(state: S): number | undefined | null;
  flowOverlay(state: S): boolean;
  readyPromiseResolve(): (() => void) | undefined;
  readyPromise(): Promise<unknown>;
  fictiveFlowPage(S: State): FlowpageModel | undefined;
  noMoreFlowPages(S: State): boolean | undefined;
};

export interface NamespacedGetters {
  'campaign/demoToken': string | undefined;
  'campaign/data': CampaignData | undefined;
  'campaign/model': CampaignModel;
  'campaign/state': CampaignState;
  'campaign/flowId': number | undefined;
  'campaign/flowIndex': number | undefined | null;
  'campaign/popoverId': number | undefined | null;
  'campaign/flowOverlay': boolean;
  'campaign/readyPromiseResolve': (() => void) | undefined;
  'campaign/readyPromise': Promise<void>;
  'campaign/fictiveFlowPage': FlowpageModel | undefined;
  'campaign/noMoreFlowPages': boolean;
}

let readyPromiseResolve: (() => void) | undefined;
// @ts-ignore-next-line
// eslint-disable-next-line
const readyPromise = new Promise((resolve) => {
  // eslint-disable-next-line
  // @ts-ignore-next-line
  readyPromiseResolve = resolve;
});

export const getters: GetterTree<State, RootState> & Getters = {
  demoToken: (state) => {
    return state?.demoToken ?? undefined;
  },
  data: (state) => {
    return state?.data ?? undefined;
  },
  fictiveFlowPage: (state) => {
    return state.fictiveFlowPage;
  },
  model: (state) => {
    return state?.model ?? undefined;
  },
  state: (state) => {
    return state?.model?.state ?? undefined;
  },
  flowId: (state) => {
    return state?.flowId ?? undefined;
  },
  flowIndex: (state) => {
    if (state.flowId === undefined) {
      return undefined;
    }
    return state?.model?.getFlowPageIndex(state.flowId);
  },
  popoverId: (state) => {
    return state?.popoverId;
  },
  flowOverlay: (state) => {
    return state.flowOverlay;
  },
  readyPromiseResolve: () => {
    if (readyPromiseResolve) {
      return readyPromiseResolve;
    }
  },
  readyPromise: () => {
    return readyPromise;
  },
  noMoreFlowPages: (state) => {
    return state?.noMoreFlowPages;
  }
};
